var _circle, _path, _path2, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.24 96.77",
    width: "400pt",
    height: "400pt"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#171D26",
    cx: 76.04,
    cy: 22.8,
    r: 22.23
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EE9AB2",
    d: "M2.7.48h44.45v44.45H2.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC550",
    d: "M76.04 54.42l11.6 20.54 11.6 20.53h-46.4l11.6-20.53z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#5263F3",
    cx: 24.93,
    cy: 73.58,
    r: 22.23
  })));
}

export default SvgIconDark;